import { useContext } from "react";
import {
  FeatureFlagsContext,
  type FeatureFlags,
} from "@/contexts/FeatureFlagsContext";

const FeatureFlagsPanelInner = () => {
  const ctx = useContext(FeatureFlagsContext);
  if (!ctx) return null;
  const { flags, setFlag, reset } = ctx;

  return (
    <details className="fixed bottom-2 right-2 z-50 max-w-xs rounded-lg border border-slate-200 bg-white p-3 text-xs shadow-elevated">
      <summary className="cursor-pointer font-medium text-ink-primary">
        Feature Flags (dev)
      </summary>
      <div className="mt-2 space-y-1">
        {(Object.keys(flags) as Array<keyof FeatureFlags>).map((key) => (
          <label
            key={key}
            className="flex items-center gap-2 text-ink-secondary"
          >
            <input
              type="checkbox"
              checked={flags[key]}
              onChange={(e) => setFlag(key, e.target.checked)}
              className="h-3.5 w-3.5"
            />
            <span className="font-mono">{key}</span>
          </label>
        ))}
        <button
          type="button"
          onClick={reset}
          className="mt-1 text-xs text-accent-red hover:underline"
        >
          Reset to defaults
        </button>
      </div>
    </details>
  );
};

export const FeatureFlagsPanel = () => {
  if (!import.meta.env.DEV) return null;
  try {
    return <FeatureFlagsPanelInner />;
  } catch {
    return null;
  }
};